import { LivemapService } from '@wemap/core';
import { Container, Stack } from 'react-bootstrap';
import { createRoot } from 'react-dom/client';
import { useEffect, useState } from 'react';
import { PropTypes } from 'prop-types';

const WEMAP_API_BASE_URL = 'https://api.getwemap.com/v3.0';

import RoutingComponent from './routing-component.jsx';
import ArNavComponent from './ar-nav-component.jsx';

import 'bootstrap/dist/css/bootstrap.min.css';
import './snippet-validation.css';

document.title = 'Wemap - Snippet validation';

const urlParams = new URLSearchParams(window.location.search);
const _emmid = urlParams.get('emmid');
if (!_emmid) {
    location.href
    = location.href
    + (location.href.indexOf('?') > -1 ? '&' : '?')
    + 'emmid='
    + prompt('emmid');
}

function App({ emmid }) {
    const [config, setConfig] = useState(null);

    useEffect(() => {
        const livemapService = new LivemapService(WEMAP_API_BASE_URL);
        livemapService.fetchLivemap(String(emmid)).then(setConfig);
    }, []);

    if (!config) {
        return 'Loading';
    }
    const { snippet } = config;

    return (
        <Container id="main">
            <Stack gap={4}>
                <Container>
                    <h1>{config.name}</h1>
                    <h4>by {config.author.name}</h4>
                    <a href={`https://pro.getwemap.com/#/app/livemaps/${emmid}/parameters`}>Link to the snippet</a>
                </Container>
                <Container>
                    <h2>Routing</h2>
                    <RoutingComponent snippet={snippet}
                        emmid={emmid} />
                </Container>
                <Container>
                    <h2>Augmented Reality &amp; Navigation</h2>
                    <ArNavComponent snippet={snippet} />
                </Container>
            </Stack>
        </Container>
    );
}
App.propTypes = {
    emmid: PropTypes.number
};

createRoot(document.getElementById('app')).render(<App emmid={Number(_emmid)} />);
